import request from '@/utils/request'

const getList = (data) => {
  const { userName, fullName, registerDate, type, page, limit, sort } = data
  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${
    sort.type
  }`

  if (userName) query += `&userName=${encodeURI(userName)}`
  if (fullName) query += `&fullName=${encodeURI(fullName)}`
  if (registerDate) query += `&registerDate=${encodeURI(registerDate)}`
  if (type) query += `&type=${encodeURI(type)}`

  return request({
    url: `/api/users?${query}`,
    method: 'get'
  })
}

const create = (data) => {
  return request({
    url: `/api/users`,
    method: 'post',
    data
  })
}

const update = (data) => {
  const { id } = data
  return request({
    url: `/api/users/${id}`,
    method: 'patch',
    data
  })
}

const remove = (id) => {
  return request({
    url: `/api/users/${id}`,
    method: 'delete'
  })
}

const detail = (id) => {
  return request({
    url: `/api/users/${id}`,
    method: 'get'
  })
}

const download = () => {
  return request({
    url: `/api/users/download`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  getList,
  create,
  update,
  remove,
  detail,
  download
}
